import React, { useMemo } from 'react';
import { DefaultList as List } from 'services/UIUtils';
import SelectableListItem from 'components/Utils/SelectableListItem';
import DocumentBadge from '../DocumentBadge';
import { UncontrolledCollapse } from 'components/Utils/Collapse';

const DocumentListByCategory = ({
  documents,
  receipts,
  prescriptions,
  selected = [],
  onDocumentClicked,
  loading = false,
  isItemChecked,
  isItemSelected,
  renderBadge,
  showTotal = false,
}) => {
  const documentsByType = useMemo(() => {
    let result = {};
    documents.forEach((document) => {
      let { document_type = 'Uncategorized' } = document;
      result[document_type] = result[document_type] || [];
      result[document_type].push(document);
    });
    if ((prescriptions || []).length > 0) result.Prescriptions = [...(prescriptions || [])];
    if ((receipts || []).length > 0) result.Receipts = [...(receipts || [])];
    return result;
  }, [documents, prescriptions, receipts]);

  const list = useMemo(() => {
    let keys = Object.keys(documentsByType);
    keys.sort();
    return keys.map((type) => {
      let numberChecked = 0;
      let entries = documentsByType[type].map((document) => {
        let isSelected = isItemSelected(document);
        let isChecked = isItemChecked(document, selected);
        if (isChecked) numberChecked++;
        return (
          <SelectableListItem
            key={document.id}
            onClick={() => onDocumentClicked(document)}
            selected={isSelected}
            item={renderBadge ? renderBadge(document) : <DocumentBadge item={document} />}
          />
        );
      });
      let total = entries.length;
      let title = showTotal ? `${type} (${total})` : `${type} (${numberChecked}/${total})`;
      return <UncontrolledCollapse title={title}>{entries}</UncontrolledCollapse>;
    });
  }, [documentsByType, selected]);

  return (
    <List>
      {!loading && list.length === 0 && <NotFoundScreen />}
      {list}
    </List>
  );
};

const NotFoundScreen = (props) => (
  <div className="not-found">
    <span>No documents found</span>
  </div>
);

export default DocumentListByCategory;
